import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { AngleDownIcon } from '@10xLabs/react-web/components/Icons/AngleDown'
import { SecondaryInfo } from 'features/App/components/SecondaryInfo'
import { ChangeActions } from 'features/Changes/components/Actions'
import { ChangeBookings } from 'features/Changes/components/Bookings'
import { ChangeDetails } from 'features/Changes/components/ChangeDetails'
import { ChangeStatus } from 'features/Changes/components/Status'
import { ChangeType } from 'features/Changes/components/Type'
import { canCancelScheduledCommand } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const AngleDownWrapper = styled.div<TSFixMe>`
  display: flex;
`

const StyledAngleDownIcon = styled(AngleDownIcon)<TSFixMe>`
  transform: rotate(${(props): TSFixMe => (props.isDetailsOpen ? '180deg' : '0deg')});
  width: 24px;
  height: 24px;
  fill: #1b1b3d;
`

const MainTr = styled(Tr)<TSFixMe>`
  box-shadow: ${(props): TSFixMe =>
    props.isDetailsOpen ? '0 4px 7px 0 rgba(0, 0, 0, 0.21)' : '0 1px 1px 0 rgba(0, 0, 0, 0.16)'};
  background-color: transparent;
  cursor: pointer;

  &:nth-child(even) {
    background-color: transparent;
  }
`

const MainTd = styled(Td)<TSFixMe>`
  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

const DetailsTr = styled(Tr)<TSFixMe>`
  background-color: rgba(236, 236, 236, 0.3);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.16);

  &:nth-child(even) {
    background-color: rgba(236, 236, 236, 0.3);
  }
`

const DetailsTd = styled(Td)<TSFixMe>`
  padding-bottom: 0;

  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

const getDetailsColSpan = (canModifyChange: TSFixMe, showExecuteAt: TSFixMe, showBookings: TSFixMe): TSFixMe => {
  let colSpan = 6
  if (showBookings) {
    colSpan += 1
  }
  if (showExecuteAt) {
    colSpan += 1
  }
  if (canModifyChange) {
    colSpan += 1
  }

  return colSpan
}

const ChangeItem = ({ change, canModifyChange, showExecuteAt, showBookings }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [isDetailsOpen, setDetailsOpen] = useState(false)

  const lastChange = change.statusChanges[change.statusChanges.length - 1]

  return (
    <>
      <MainTr onClick={(): TSFixMe => setDetailsOpen(!isDetailsOpen)} isDetailsOpen={isDetailsOpen}>
        <MainTd>
          <CopyToClipboardWrapper>
            <div>{change.id.substring(0, 8)}</div>

            <CopyToClipboard str={change.id} />
          </CopyToClipboardWrapper>
        </MainTd>

        <MainTd>
          <ChangeStatus status={change.status} />
        </MainTd>

        <MainTd>
          <FormattedDate intl={intl} value={lastChange.changedAt} month="2-digit" day="2-digit" year="numeric" />

          <SecondaryInfo>
            <FormattedTimeByDate intl={intl} date={lastChange.changedAt} />
          </SecondaryInfo>
        </MainTd>

        <MainTd>
          <ChangeType type={change.type} />
        </MainTd>

        <MainTd>{change.user.username}</MainTd>

        {showBookings && (
          <MainTd>
            <ChangeBookings bookings={change.bookings} />
          </MainTd>
        )}

        {showExecuteAt &&
          (change.executeAt ? (
            <MainTd>
              <FormattedDate intl={intl} value={change.executeAt} month="2-digit" day="2-digit" year="numeric" />

              <SecondaryInfo>
                <FormattedTimeByDate intl={intl} date={change.executeAt} />
              </SecondaryInfo>
            </MainTd>
          ) : (
            <MainTd>-</MainTd>
          ))}

        {canModifyChange && (
          <MainTd>
            <ChangeActions change={change} />
          </MainTd>
        )}

        <MainTd>
          <AngleDownWrapper>
            <StyledAngleDownIcon isDetailsOpen={isDetailsOpen} />
          </AngleDownWrapper>
        </MainTd>
      </MainTr>

      {isDetailsOpen && (
        <DetailsTr>
          <DetailsTd colSpan={getDetailsColSpan(canModifyChange, showBookings, showExecuteAt)}>
            <ChangeDetails change={change} showBookings={showBookings} />
          </DetailsTd>
        </DetailsTr>
      )}
    </>
  )
}

const Wrapper = styled.div<TSFixMe>`
  margin: 0 -30px;
`

const StyledTh = styled(Th)<TSFixMe>`
  :first-child {
    padding-left: 40px;
  }

  :last-child {
    padding-right: 40px;
  }
`

export const ChangesList = ({ changes = [], showBookings, showExecuteAt, showCancel }: TSFixMe): TSFixMe => {
  const login = useLogin()

  const canModifyChange = canCancelScheduledCommand(login.accessToken.policies) && showCancel

  return (
    <Wrapper>
      <TableContainer overflow>
        <Table marginBottom>
          <Thead>
            <Tr>
              <StyledTh>
                <FormattedMessage id="dictionary.id" defaultMessage="Id" />
              </StyledTh>

              <StyledTh>
                <FormattedMessage id="dictionary.status" defaultMessage="Status" />
              </StyledTh>

              <StyledTh>
                <FormattedMessage id="changes.list.lastChangeAt" defaultMessage="Last change at" />
              </StyledTh>

              <StyledTh>
                <FormattedMessage id="dictionary.type" defaultMessage="Type" />
              </StyledTh>

              <StyledTh>
                <FormattedMessage id="dictionary.user" defaultMessage="User" />
              </StyledTh>

              {showBookings && (
                <StyledTh>
                  <FormattedMessage id="dictionary.bookings" defaultMessage="Bookings" />
                </StyledTh>
              )}

              {showExecuteAt && (
                <StyledTh>
                  <FormattedMessage id="dictionary.applyFrom" defaultMessage="Apply from" />
                </StyledTh>
              )}

              {canModifyChange && (
                <StyledTh>
                  <FormattedMessage id="dictionary.actions" defaultMessage="Actions" />
                </StyledTh>
              )}

              <StyledTh />
            </Tr>
          </Thead>

          <Tbody>
            {changes.map((change: TSFixMe, index: number): TSFixMe => {
              return (
                <ChangeItem
                  change={change}
                  canModifyChange={canModifyChange}
                  showExecuteAt={showExecuteAt}
                  showBookings={showBookings}
                  key={index}
                />
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Wrapper>
  )
}
